module.exports = "/img/vdf_logo.png?2dc34b55a8463b5dba9ebcafb6c70993";